import { filterListStyles as styles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        ${styles.wrapper?.css}
        gap: 8px;
        margin-bottom: 24px;
    `,
};

styles.filterTag = {
    ...styles.filterTag,
    css: css`
        ${styles.filterTag?.css}
        max-width: 100%;
        margin: 0;
        block-size: auto;
    `,
};

styles.filterText = {
    ...styles.filterText,
    css: css`
        margin: 0;
    `,
};

styles.clearAllLink = {
    ...styles.clearAllLink,
    css: css`
        padding: 0;
    `,
};
